import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as apiCompany from "../../../api/apiCompany"
import * as Auth from "../../Login/Auth"

/**
 * 部門名稱
 * @param {*} param0 
 */
export function ItemRoleName({roleName, setRoleName}){
    return (
        <div className="row">
            <div className="col-sm-12">
                <div className="form-group">
                    <label htmlFor="exampleInputEmail1">角色名稱</label>
                    <input type="text" className="form-control" placeholder="" value={roleName} onChange={e=>setRoleName(e.target.value)} />
                    </div>
            </div>
        </div>
    )
}

/**
 * 上級列表(下拉選單)
 * @param {*} param0 
 */
export function ItemRoleListSelect({departmentId, managerRoleId, setManagerRoleId, change}){
    const [mDepartmentId, setDepartmentId] = useState("")
    const [mManagerRoleId, setRoleId] = useState(managerRoleId)
    const [roleList, setRoleList] = useState([])
    const [mChange, setChange] = useState(change)
    
    useEffect(()=>{
        if(departmentId !== undefined && mDepartmentId !== departmentId){
            setDepartmentId(departmentId)
            getRoleListByCompany();
        }
    })

    useEffect(()=>{
        if(change !== mChange){
            setChange(change)
            getRoleListByCompany();
        }
    })

    useEffect(()=>{
        if(managerRoleId !== undefined && managerRoleId !== mManagerRoleId){
            setRoleId(managerRoleId)
        }
    })

    function getRoleListByCompany(){
        apiCompany.getRoleListByCompany({
            departmentId, 
            success: (obj)=>{
                setRoleList(obj.list)
                //console.log(obj)
            },
            failure: ()=>{

            }
        })
    }

    return (
        <div className="row">
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">上級</label>
                        <select className="form-control" value={mManagerRoleId} onChange={e=>setManagerRoleId(e.target.value)}>
                        <option  value=""></option>
                        <RoleSelect roleList={roleList} />
                        </select>
                    </div>
                </div>
        </div>
    )
}

function RoleSelect({roleList}){
    if(roleList === undefined){
        return <></>
    }else{
        return (
            roleList.map((role)=>(
                <option key={role.roleId} value={role.roleId}>{role.departmentName} - {role.roleName}</option>
            ))
        )
    }
}

export function ItemRoleIsSupervisor({isSupervisor, setIsSupervisor}){
    function set(){
        console.log("set")
        setIsSupervisor(isSupervisor==1?0:1)
    }
    return(
        <div className="row">
            <div className="col-sm-12">                      
                <div className="custom-control custom-switch">
                    <input type="checkbox" checked={isSupervisor} onChange={e=>setIsSupervisor(e.target.checked?1:0)} />
                    <label className="custom-control-label" htmlFor="customSwitches" onClick={set}>是否為主管</label>
                </div>
            </div>
        </div>
    )
}

export function ItemRoleIsDisable({isDisable, setisDisable}){
    return(
        <div className="row">
            <div className="col-sm-12">
                
            <div className="custom-control custom-switch">
                <input type="checkbox" checked={isDisable} onChange={e=>setisDisable(e.target.checked?1:0)} />
                <label className="custom-control-label" htmlFor="customSwitches">是否停用</label>
            </div>
            </div>
        </div>
    )
}

